import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getDoctorsUrl         = '/api/admin/doctor/getDoctors';
const postDoctorUrl         = '/api/admin/doctor/postDoctor';
const getSlotsUrl           = '/api/admin/doctor/getSlots';
const assignDoctorUrl       = '/api/admin/doctor/assignDoctor';
const scheduleClientUrl     = '/api/admin/doctor/scheduleClient';

export const getDoctorList = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getDoctorsUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const postDoctor = async (doctor) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postDoctorUrl,
        { doctor },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const getSlots = async (doctorId, date) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        getSlotsUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { doctorId, date }} 
    );
    return response;
};

export const assignDoctor = async (assign) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        assignDoctorUrl,
        { assign },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const scheduleClient = async (schedule) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        scheduleClientUrl,
        { schedule },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};